import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  WEAPON_KEYWORD_OPTIONS,
  WeaponLimitation, 
} from "@dndModels";
import { 
  ABILITY_SCORES_EXPANDED,
  ATTACK_TYPES, 
  DAMAGE_TYPES 
} from "@dndModels/Constants";
import { AbilityScoreExpandedType, AttackType, DamageType } from "@dndModels/Types";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import StringBox from "@components/input/strings/StringBox";

interface Props { 
  obj: WeaponLimitation;
  change_time?: number;
  onChange: (changed: WeaponLimitation) => void;
  onDelete?: () => void;
  disabled?: boolean;
}

export default function WeaponLimitInput({ 
  obj,
  change_time = 0,
  onChange,
  onDelete, // I'll add an implementation for this later.
  disabled = false 
}: Props) {
  const [prev_change_time, setChangeTime] = useState(change_time);

  useEffect(() => {
    if (prev_change_time !== change_time) {
      setChangeTime(change_time);
    }
  }, [prev_change_time, change_time, setChangeTime]);
  
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        {/* <SelectObjectBox 
          name="Specific Weapons" 
          data_type="item"
          filter={{ item_type: "Weapon" }}
          values={obj.item_ids} 
          multiple
          disabled={disabled}
          onChange={(changed: string[]) => {
            const new_obj = obj;
            new_obj.item_ids = changed;
            
            onChange(new_obj);
          }} 
        /> */}
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox 
          name="Weapon Keywords" 
          options={WEAPON_KEYWORD_OPTIONS}
          extra_options={["Any","Any Weapon","Unarmed Strike"]}
          values={obj.weapon_keyword_ids} 
          multiple
          disabled={disabled}
          onChange={(values: string[]) => {
            const new_obj = obj;
            new_obj.weapon_keyword_ids = values;
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox 
          name="Excluded Weapon Keywords" 
          options={WEAPON_KEYWORD_OPTIONS}
          extra_options={["Any","Any Weapon","Unarmed Strike"]}
          values={obj.excluded_keyword_ids} 
          multiple
          disabled={disabled}
          onChange={(values: string[]) => {
            const new_obj = obj;
            new_obj.excluded_keyword_ids = values;
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectObjectBox 
          name="Magic Item Keywords" 
          data_type="magic_item_keyword"
          values={obj.mik_ids} 
          multiple
          disabled={disabled}
          onChange={(changed: string[]) => {
            const new_obj = obj;
            new_obj.mik_ids = changed;
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectObjectBox 
          name="Excluded Magic Item Keywords" 
          data_type="magic_item_keyword"
          values={obj.excluded_mik_ids} 
          multiple
          disabled={disabled}
          onChange={(changed: string[]) => {
            const new_obj = obj;
            new_obj.excluded_mik_ids = changed;
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox 
          name="Attack Types" 
          options={ATTACK_TYPES}
          values={obj.attack_types} 
          multiple
          disabled={disabled}
          onChange={(changed: AttackType[]) => {
            const new_obj = obj;
            new_obj.attack_types = changed;
            
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox 
          name="Attack Modifiers" 
          options={ABILITY_SCORES_EXPANDED}
          values={obj.attack_mods} 
          multiple
          disabled={disabled}
          onChange={(changed: AbilityScoreExpandedType[]) => {
            const new_obj = obj;
            new_obj.attack_mods = changed;
            
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 12
        }}>
        <Grid container spacing={0} direction="row">
          <Grid
            size={{
              xs: 12
            }}>
            <SelectStringBox 
              name="Damage Types" 
              options={DAMAGE_TYPES}
              // extra_options={["Selectable"]}
              values={obj.damage_types} 
              multiple
              disabled={disabled}
              onChange={(changed: (DamageType | "Selectable")[]) => {
                const new_obj = obj;
                new_obj.damage_types = changed;
                
                onChange(new_obj);
              }} 
            />
          </Grid>
          { obj.damage_types.includes("Selectable") && 
            <Grid
              size={{
                xs: 12
              }}>
              <StringBox 
                name="Selectable Key" 
                value={obj.damage_selectable_key} 
                disabled={disabled}
                onBlur={(changed: string) => {
                  const new_obj = obj;
                  new_obj.damage_selectable_key = changed;
                  
                  onChange(new_obj);
                }} 
              />
            </Grid>
          }
        </Grid>
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox
          name="Proficient"
          value={ obj.proficient }
          options={["Ignore","No","Yes"]}
          onChange={(changed: "Yes" | "No" | "Ignore") => {
            const new_obj = obj;
            new_obj.proficient = changed;
            
            onChange(new_obj);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox
          name="Have Weapon Mastery"
          value={ obj.have_weapon_mastery }
          options={["Ignore","No","Yes"]}
          onChange={(changed: "Yes" | "No" | "Ignore") => {
            const new_obj = obj;
            new_obj.have_weapon_mastery = changed;
            
            onChange(new_obj);
          }}
        />
      </Grid>
    </Grid>
  );
}
